import { TargetAttributeDto, TargetAttributeDtoType } from '@/generated/model';
import i18n from '@/i18n';
import { fulldate } from '@/utilities/dateUtils';
import { TFunction } from 'i18next';

export function getContent(targetAttribute: TargetAttributeDto, t: TFunction<'translation', undefined>) {
  if (!targetAttribute.value && targetAttribute.various) {
    return t('targetAttributes.variousValues');
  }

  // 0 is valid value
  const attributeValue = targetAttribute.value;
  if (attributeValue == undefined || attributeValue == null || String(attributeValue) == '') {
    return '';
  }

  switch (targetAttribute.type) {
    case TargetAttributeDtoType['@class']:
      return `${attributeValue.brand} ${attributeValue.type}`;
    case TargetAttributeDtoType['@list']:
      return `${attributeValue.translation}`;
    case TargetAttributeDtoType['@boolean']:
      return `${Boolean(attributeValue)}`;
    case TargetAttributeDtoType['@date']: {
      if (Number(attributeValue) === 0) {
        return '';
      }
      const value = attributeValue ? fulldate(Number(attributeValue) * 1000, t) : null;
      return `${value}`;
    }
    default:
      return `${attributeValue}`;
  }
}

export function translateKey(row: TargetAttributeDto, t: TFunction<'translation', undefined>) {
  const translationKey = `targetAttributes.keys.${row.key}`;
  return i18n.exists(translationKey) ? t(translationKey) : (row.translatedKey ?? row.key);
}
